module.exports = __webpack_public_path__ + "img/head-shoulders.ae4de7cf.png";